__turbopack_context__.v({
  "select": "simple-select-module-scss-module__wckH2W__select",
  "selectWrapper": "simple-select-module-scss-module__wckH2W__selectWrapper",
});
